import React from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import './style.css';

interface Props {
  text: string;
}

export const TextShowMore: React.FC<Props> = ({ text }) => {
  const [isClamped, setIsClamped] = React.useState<boolean>(true);
  const [showButton, setShowButton] = React.useState(true);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const handleClick = () => setIsClamped(!isClamped);

  React.useEffect(() => {
    const hasClamping = (el: HTMLElement) => {
      const { clientHeight, scrollHeight } = el;
      return clientHeight !== scrollHeight;
    };

    const checkButtonAvailability = () => {
      const container = containerRef.current;

      if (container) {
        const hadClampClass = container.classList.contains('clamp');

        if (!hadClampClass) {
          container.classList.add('clamp');
        }

        setShowButton(hasClamping(container));

        if (!hadClampClass) {
          container.classList.remove('clamp');
        }
      }
    };

    const container = containerRef.current as HTMLElement;
    const observer = new ResizeObserver(checkButtonAvailability);
    observer.observe(container);

    return () => {
      observer.unobserve(container);
    };
  }, [containerRef]);

  return (
    <Box>
      <Text
        textStyle="body2"
        mt={2}
        noOfLines={isClamped ? 3 : undefined}
        ref={containerRef}
      >
        {text}
      </Text>
      {showButton && (
        <Button
          variant="link"
          onClick={handleClick}
          fontWeight="normal"
          color="azure.1"
          _focus={{ boxShadow: 'none' }}
          _hover={{ textDecoration: 'initial' }}
          mt={1}
        >
          <Text textStyle="body2">
            {isClamped ? 'Читать полностью' : 'Скрыть'}
          </Text>
        </Button>
      )}
    </Box>
  );
};
